import { ColumnDef } from '../../../data-table';

interface TrackingRow {
  trackingUtm: Record<string, string> | null;
  referrer: string | null;
}

const formatLabel = (key: string) =>
  key
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const buildTrackingColumns = <T extends TrackingRow>(utmKeys: string[]): ColumnDef<T>[] => [
  ...utmKeys.map<ColumnDef<T>>((key) => ({
    id: `tracking-${key}`,
    header: formatLabel(key),
    enableSorting: false,
    cell: ({ row }) => <span>{row.original.trackingUtm?.[key] ?? ''}</span>,
  })),
  {
    id: 'referrer',
    header: 'Referrer',
    enableSorting: false,
    cell: ({ row }) => <span>{row.original.referrer ?? ''}</span>,
  },
];
